import { __assign, __rest } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
import Button from '../../Button';
var MatureAgeBlockedOverlay = function (_a) {
    var deviation = _a.deviation, overrideMatureFilter = _a.overrideMatureFilter, props = __rest(_a, ["deviation", "overrideMatureFilter"]);
    var t = useTranslation().t;
    return (React.createElement(HiddenLayout, __assign({ deviation: deviation, icon: React.createElement(Hidden, null), title: t('deviationview.blocked.mature.underage'), text: props.compact ? null : t('deviationview.blocked.mature.underage.text'), button: React.createElement(Button, { view: "b14", height: props.compact ? 'small' : 'medium', onClick: overrideMatureFilter }, t('deviationview.blocked.displayAnyway')) }, props)));
};
MatureAgeBlockedOverlay.displayName = 'MatureAgeBlockedOverlay';
export default MatureAgeBlockedOverlay;
//# sourceMappingURL=MatureAgeBlocked.js.map